import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { NotificationDetailsFragmentDoc } from '../../../../NotificationTray/graphql/fragments/generated/NotificationDetails';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserBellNotificationSubscriptionVariables = Types.Exact<{
  input: Types.UserBellNotificationSubscriptionInput;
}>;


export type UserBellNotificationSubscription = { userBellNotification: { type: Types.UserBellNotificationsSubscriptionPayloadTypeEnum, unreadNotificationsCount: number, unresolvedNotificationsCount: number, userNotification?: { id: string, createdAt: string, message: string, icon?: string | null, redirectPath: string, status: Types.UserNotificationStatusEnum, userProfileIcon?: string | null, type: Types.NotificationActionTypeEnum, quotedMessage?: string | null } | null } };


export const UserBellNotificationDocument = /*#__PURE__*/ gql`
    subscription userBellNotification($input: UserBellNotificationSubscriptionInput!) {
  userBellNotification(data: $input) {
    userNotification {
      ...NotificationDetails
    }
    type
    unreadNotificationsCount
    unresolvedNotificationsCount
  }
}
    ${NotificationDetailsFragmentDoc}`;

export function useUserBellNotificationSubscription<TData = UserBellNotificationSubscription>(options: Omit<Urql.UseSubscriptionArgs<UserBellNotificationSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<UserBellNotificationSubscription, TData>) {
  return Urql.useSubscription<UserBellNotificationSubscription, TData, UserBellNotificationSubscriptionVariables>({ query: UserBellNotificationDocument, ...options }, handler);
};